import { createRouter, createWebHistory } from "vue-router";

const routes = [
	{
		path: "/",
		name: "home",
		redirect: "/widgets",
	},
	{
		meta: {
			title: "Users",
		},
		path: "/users",
		name: "users",
		component: () => import(/* webpackChunkName: "users" */ "../views/Users"),
	},
	{
		meta: {
			title: "User create",
		},
		path: "/user/create",
		name: "userCreate",
		component: () => import(/* webpackChunkName: "users" */ "../views/UserCreate"),
	},
	{
		meta: {
			title: "User edit",
		},
		path: "/user/:userId",
		name: "userEdit",
		component: () => import(/* webpackChunkName: "users" */ "../views/UserEdit"),
	},
	{
		meta: {
			title: "Login",
			formScreen: true,
		},
		path: "/login",
		name: "login",
		component: () => import(/* webpackChunkName: "login" */ "../views/Login"),
	},
	{
		meta: {
			title: "Widget API Tokens",
		},
		path: "/widgets",
		name: "widgets",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokens"),
	},
	{
		meta: {
			title: "Widget Statistics",
		},
		path: "/widgets/stats",
		name: "widgetStats",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetUsageStats"),
	},
	{
		meta: {
			title: "Create Widget Token",
		},
		path: "/widgets/create",
		name: "widgetTokenCreate",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokenForm"),
	},
	{
		meta: {
			title: "Edit Widget Token",
		},
		path: "/widgets/:id/edit",
		name: "widgetTokenEdit",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokenForm"),
	},
	{
		meta: {
			title: "Widget System Settings",
		},
		path: "/widgets/system-settings",
		name: "widgetSystemSettings",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetSystemSettings"),
	},
	{
		meta: {
			title: "Widget Plugin Manager",
		},
		path: "/widgets/plugins",
		name: "widgetPluginManager",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetPluginManager"),
	},
	{
		meta: {
			title: "Widget Sessions",
		},
		path: "/widgets/sessions",
		name: "widgetSessions",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetSessions"),
	},
];

const router = createRouter({
	mode: "history",
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { top: 0 };
	},
});

export default router;
